module.exports = __webpack_public_path__ + "img/resource-zy.b288b7fd.png";